import { createFileRoute } from '@tanstack/react-router'

import EditSwastaPage from '@/components/pages/backoffice/_ktg-penyuluh/swasta/_swastaId/_edit/containers/EditSwastaPage'

export const Route = createFileRoute(
  '/_backoffice/ktg-penyuluh/swasta/$swastaId/edit/'
)({
  component: EditSwastaPage
})
